<vp-newsletter
	[editableInStoryblok]="_editable()"
	[formFields]="newsletterForm"
	[newsletterSubmitError]="newsletterSubmitError"
	[newsletterSubmitted]="newsletterSubmitted"
	[newsletterSubmitting]="newsletterSubmitting"
	(formSubmit)="onSubmit($event)"
>
	<sb-heading-group
		[isSection]="true"
		[overline]="overline()"
		[title]="title()"
		alignment="center"
		headingType="h3"
		size="lg"
	/>
</vp-newsletter>
